import React from "react";
import { IoLogoGoogle } from "react-icons/io5";

export const GoogleAccountEditComponent = () => {
	return (
		<div className="flex flex-col items-center flex-grow">
			<div className="text-2xl font-light mb-4">Account Details</div>
			<div className="text-sm font-light mb-4">
				Account modification is done through Google. Click the button
				below to go to Google's account page.
			</div>
			<a
				href="https://myaccount.google.com"
				target="_blank"
				className="p-4 border rounded-full hover:bg-black hover:text-white cursor-pointer"
			>
				<IoLogoGoogle size={32} />
			</a>
		</div>
	);
};
